/** Methods that can change the documents a tenant owns; GET/HEAD never do. */
const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete'])

export function isMutatingRequest(method?: string): boolean {
  return MUTATING_METHODS.has(method?.toLowerCase() ?? '')
}
